import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { routeTitles } from "../config/routeTitles";

function DynamicTitle() {
  const { t } = useTranslation("layout");
  const location = useLocation();
  const title = t(routeTitles[location.pathname] || "metadata.defaultTitle");

  useEffect(() => {
    // Force update the title
    document.title = title;
  }, [location.pathname, title]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

export default DynamicTitle;
